<template>
  <div v-if="statement" class="flex gap-x-4">
    <multi-select
      v-model="statement.data.value"
      :options="fetchChoice"
      :searchable="true"
      :can-clear="false"
      :error="errors?.value"
      :disabled="disabled"
      class="grow mt-4"
    />
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import MultiSelect from '@utils/Multiselect.vue';
import { collOptionsProvider } from '@utils/table/hooks/provider';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { FilterPrototype, LogicStatement, MaybeHydra } from '@/entities/Entities';

interface Props {
  modelValue?: MaybeHydra<
    LogicStatement<{
      value: boolean;
    }>
  >;
  prototype: FilterPrototype<
    { choiceUrl: string; propertyName: string; propertyValue: string },
    Record<string, never>
  >;
  errors?: object;
  disabled?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);
const statement = useVModel(props, 'modelValue', emit, { passive: true });

const { t } = useI18n();

interface Option {
  value: string | null;
  label: string;
}

const fetchChoice = ref<Option[] | undefined>(undefined);

const loadOptions = async () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchChoice.value = await collOptionsProvider(props.prototype.options.choiceUrl, (el: any) => ({
    label: el[props.prototype?.options?.propertyName],
    value: el[props.prototype?.options?.propertyValue],
  }))();

  fetchChoice.value.unshift({ label: t(`logicStatement.nullableChoice.${props.modelValue?.name}.null`), value: 'null' });
};

loadOptions();

</script>

<style lang="scss" scoped></style>
